import initMap from '../util/initMap.js';

const siedlungen = function() {
  console.log('hello from siedlung-single');

  setTimeout(function() {
    setupMap();
  }, 500);

  function setupMap() {
    // MAPS INIT
    $.getJSON('../wp-content/themes/bbz_2025/resources/assets/scripts/util/mapStyleGrey.json', function(mapStyle){

      $.ajax({
        dataType: 'json',
        beforeSend: function() {
          console.log('fetching siedlungen');
        },
        url: window.location.protocol + '//' + window.location.host + '/wp-json/wp/v2/pages?parent=10',
        success: function(siedlungen) {
          ///console.log(siedlungen);
          initMap('map', mapStyle, siedlungen);
        },
        error: function(jqXHR,textStatus,errorThrown) {
          console.log(jqXHR);
          console.log(textStatus);
          console.log(errorThrown);
        },
      })
    });
  }
}

export default siedlungen





// WEBPACK FOOTER //
// ./scripts/barba-views/siedlungen.js